import { useState } from "react";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import { Modal } from "react-bootstrap";
import CustomSelect from "../../../component/CustomSelect";
import CustomImageUpload from "../../../component/CustomImageUpload";
import { toast } from "react-toastify";
import Icons from "../../../myIcon/Icons";

const addFeatureEndpoint = ApiEndpoints.featureCategory.featureCreate;

export default function AddFeatureCategory({ show, onHide }) {
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");
  const StatusData = [{ _id: "1", name: "Disable" }, { _id: "0", name: "Enable" }];
  const handleStatusChange = (e) => setStatus(e.target.value);
  const handleNameChange = (event) => setName(event.target.value);

  const [previews, setPreviews] = useState({ image: null, });
  const [postData, setPostData] = useState({
    title: "",
    brief: "",
    category_slug: "",
    thumbnail: null,
    icon: null,
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!postData.title || !postData.category_slug) {
      toast.error("Required fields missing");
      return;
    }

    const formData = new FormData();
    formData.append("title", postData.title);
    formData.append("brief", postData.brief);
    formData.append("category_slug", postData.category_slug);

    if (postData.thumbnail) {
      formData.append("thumbnail", postData.thumbnail);
    }

    if (postData.icon) {
      formData.append("icon", postData.icon);
    }

    try {
      const response = await ApiRequest("POST", addFeatureEndpoint, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success(response.message);
      onHide();
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };


  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];
      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));

      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      // For non-file inputs, update the postData state directly
      setPostData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  return (
    <>
      <Modal className="add-modal-area" show={show} onHide={onHide} size="md" aria-labelledby="contained-modal-title-vcenter" centered >
        <Modal.Body>
          <button className="modal-close-button" onClick={onHide}><Icons name="cross" /></button>
          <form onSubmit={handleSubmit}>
            <div className="add-page-sections">Add Feature</div>
            <div className="row">
              <div className="col-md-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Title<small>*</small></label>
                  </div>
                  <input name="title" type="text" placeholder="Enter Title" className="form-control" onChange={handleChange} required />
                </div>
              </div>
             
              <div className="col-md-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Slug<small>*</small></label>
                  </div>
                  <input name="category_slug" type="text" placeholder="slug" className="form-control" onChange={handleChange} required />
                </div>
              </div>


               <div className="col-md-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Brief<small>*</small></label>
                  </div>
                  <input name="brief" type="text" placeholder="Brief" className="form-control" onChange={handleChange} required />
                </div>
              </div>
            </div>
            <div className="add-page-inputs input-add-image">
              <div className="label-wrap-add">
                <label> Thumbnail Image (468 × 340)<small>*</small></label>
              </div>
              <CustomImageUpload name="thumbnail"
                acceptedFormats={[".webp"]}
                onImageChange={handleChange}
                imagePreview={previews.thumbnail}
              />
            </div>
            <div className="add-page-inputs input-add-image">
              <div className="label-wrap-add">
                <label>Icon (80 × 80)<small>*</small></label>
              </div>
              <CustomImageUpload name="icon"
                acceptedFormats={[".webp"]}
                onImageChange={handleChange}
                imagePreview={previews.icon}
              />
            </div>
            <button type="submit" className="default-btn">Save Changes<span></span></button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}




